import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import TodayIcon from '@mui/icons-material/Today';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import AddIcon from '@mui/icons-material/Add';

export default [
  {
    title: 'Menu',
    pages: [
      {
        title: 'Dashboard',
        href: '/company/dashboard',
        icon: HomeIcon,
        resource: 'dash',
      },
      {
        title: 'Visualizar Acordos',
        href: '/company/agreements',
        icon: TodayIcon,
      },
      {
        title: 'Fases',
        href: '#',
        icon: ViewStreamIcon,
        children: [
          {
            title: 'Termo de Encaminhamento',
            href: '/company/forwarding-term',
          },
          {
            title: 'Cumprimento de Acordo',
            href: '/company/agreement-compliance',
          },
        ],
      },
      {
        title: 'Cadastros',
        href: '#',
        icon: AddIcon,
        resource: '',
        children: [
          {
            title: 'Cadastro de Instituições Parceiras',
            href: '/company/partner-institution',
          },
          {
            title: 'Cadastro de Serviços e Materiais',
            href: '/company/register-services',
          },
          {
            title: 'Cadastro de Projetos',
            href: '/company/register-projects',
          },
          {
            title: 'Solicitação de Serviços e Materiais',
            href: '/company/service-solicitation',
          },
        ],
      },
      {
        title: 'Perfil',
        href: '/company/profile',
        icon: AccountCircleIcon,
      },
      {
        title: 'Sair',
        href: '/',
        icon: ExitToAppIcon,
      },
    ],
  },
];
